window.$ = window.jQuery;
_theme.isMobile = jQuery(window).width() < 768 ? true : false;
_theme.isIpad = jQuery(window).width() < 1025 ? true : false;
_theme.isIpadAndUp = jQuery(window).width() > 767 ? true : false;
_theme.isLaptopAndUp = jQuery(window).width() > 1199.99 ? true : false;
_theme.isLaptopAndDown = jQuery(window).width() < 1199 ? true : false;

_theme.getOS = function() {
  if(!window.navigator) return '';
  var userAgent = window.navigator.userAgent;
  var userAgentData = window.navigator.userAgentData;
  var platform = userAgentData ? userAgentData.platform ? userAgentData.platform :  window.navigator.platform : window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'mac-os';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'android';
  } else if (/Linux/.test(platform)) {
    os = 'linux';
  }

  return os;
}

_theme.iPhoneVersion = function(){
  var iHeight = window.screen.height;
  var iWidth = window.screen.width;

  if (iWidth === 414 && iHeight === 896) {
    return "xmax-xr";
  } else if (iWidth === 375 && iHeight === 812) {
    return "x-xs";
  } else if (iWidth === 320 && iHeight === 480) {
    return "4";
  } else if (iWidth === 375 && iHeight === 667) {
    return "6";
  } else if (iWidth === 414 && iHeight === 736) {
    return "6-plus";
  } else if (iWidth === 320 && iHeight === 568) {
    return "5";
  } else if (iHeight <= 480) {
    return "2-3";
  }
  return 'none';
}

_theme.initSliderPlayPause = function($parent, $sliderInstance, label){
  if($parent.length === 0 || $parent.find('.homepage-slider-play-pause').length === 0) return;
  if(!label) {
    label="Slider Autoplay play/pause";
  }
  
  $parent.find('.homepage-slider-play-pause').removeClass('hidden');
  const $playPausebutton = $parent.find('.homepage-slider-play-pause button');
  $playPausebutton.attr('aria-label',label+' pause');  
  $playPausebutton.on('click', function(evt){
    jQuery(this).toggleClass('active');
    let msg = 'Autoplay started. press to pause';
    let evtName =  'slickPlay'
    jQuery(this).attr('aria-label',label+' pause');
    if(jQuery(this).hasClass('active')){
      msg = 'Autoplay paused. press to play';
      evtName = 'slickPause'
      jQuery(this).attr('aria-label',label+' play');  
    }
     $sliderInstance.slick(evtName); 
    

  });
}

_theme.focusTrap = function(elem, cb, tabbableAdditionalElems, enableBackwardJourney, stopInitialFocus, disableLinearNavigation){
  if(!elem) return;
  if(!elem.length) elem = jQuery(elem);
  if(elem.length === 0) return;

  let tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
  if(tabbableAdditionalElems){
    if(Array.isArray(tabbableAdditionalElems)) tabbableElems = tabbableElems.concat(tabbableAdditionalElems)
    if(typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
  }
  let tabbable = elem.find(tabbableElems.join(',')).filter(':visible');
  let firstTabbable = tabbable.first();
  let lastTabbable = tabbable.last();
  // console.log("reun",firstTabbable,"last",tabbable)
  if(!stopInitialFocus) firstTabbable.focus();
  // if(isIos) firstTabbable.dispatchEvent(new Event('touchstart'));

  lastTabbable.off('keydown').on('keydown', function(e) {
    if(disableLinearNavigation && e.key){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        return;
      }
    }

    if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        firstTabbable.focus();
        // if(isIos) firstTabbable.dispatchEvent(new Event('touchstart'));
    }
  });

  firstTabbable.off('keydown').on('keydown', function(e) {
    if(disableLinearNavigation && e.key){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        return;
      }
    }

    if ((e.which === 9 && e.shiftKey && !enableBackwardJourney)) {
          e.preventDefault();
          lastTabbable.focus();
          // if(isIos) lastTabbable.dispatchEvent(new Event('touchstart'));
      }
  });

  elem.off('keydown').on('keydown', function(e) {
    if(disableLinearNavigation && e.key){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        return;
      }
    }

    if (e.keyCode === 27 ) {
      cb(elem, e);
    }
  });
}

_theme.focusTrapReset = function(elem, tabbableAdditionalElems){
  if(!elem) return;
  let tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
  if(tabbableAdditionalElems){
    if(Array.isArray(tabbableAdditionalElems)) tabbableElems = tabbableElems.concat(tabbableAdditionalElems)
    if(typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
  }
  let tabbable = elem.find(tabbableElems.join(',')).filter(':visible');
  let firstTabbable = tabbable.first();
  let lastTabbable = tabbable.last();
  firstTabbable.off('keydown');
  lastTabbable.off('keydown');
  elem.off('keydown');
}

_theme.focusMove = function(elem) {
  let tabbable = elem.find('select, input, textarea, button, a').filter(':visible');
  let firstTabbable = tabbable.first();

  firstTabbable.focus();
}

_theme.focusFirstTabbable = function($container, tabbableAdditionalElems){
  if(!$container || $container.length === 0) return;
  try {
    const tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
    if(tabbableAdditionalElems){
      if(Array.isArray(tabbableAdditionalElems)) tabbableElems = tabbableElems.concat(tabbableAdditionalElems)
      if(typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
    }
    const tabbable = $container.find(tabbableElems.join(',')).filter(':visible');
    tabbable.first().focus();
  } catch(err){
  }
}

_theme.handleKeyboardUpDownButtonPress = function(evt){
  const key = evt.key.toUpperCase();
  if(key === 'ARROWUP'){
    const $prevElem = $(this).prev();
    if($prevElem.length) {
      $prevElem.addClass('selected').siblings().removeClass('selected');
      setTimeout(function(){
        $prevElem.focus();
      }, 250);
    }
  }

  if(key === 'ARROWDOWN'){
    const $nextElem = $(this).next();
    if($nextElem.length) {
      $nextElem.addClass('selected').siblings().removeClass('selected');
      setTimeout(function(){
        $nextElem.focus();
      }, 250);
    }
  }

  if(key === 'TAB' && !evt.shiftKey){
    const $nextElem = $(this).next();
    if($nextElem.length === 0) evt.preventDefault();
  }

  if(key === 'ENTER' || (key === ' ' && evt.which === 32)){
    evt.target.click();
  }
}

_theme.initSlickSlider = function(selector, settings, initCallBack, afterChangeCallBack){
    if(!selector || !settings) return;
    let $productGrid = selector;
    if(typeof selector === 'string'){
      $productGrid = jQuery(selector);
    }
    if(typeof selector === "object" && !$productGrid.hasOwnProperty('length')){
      $productGrid = jQuery(selector);
    }

    if($productGrid.length === 0) return;

    if($productGrid.hasClass('slick-initialized')){
      $productGrid.slick('unslick');
    }

    $productGrid.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      slickCb(slick);
    });

    $productGrid.on('afterChange', function(event, slick, currentSlide, nextSlide){
      slickCb(slick);
      if(afterChangeCallBack && typeof afterChangeCallBack === 'function') afterChangeCallBack(slick);
    });

    $productGrid.on('init', function(event, slick, currentSlide, nextSlide){
      slickCb(slick);
      if(initCallBack && typeof initCallBack === 'function') initCallBack(slick);
    });

    $productGrid.slick(settings);

    function slickCb(slick){
      slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
      slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
      slick.$slider.find('.slick-slide:not(.slick-active)').attr('tabindex', -1);
  
      jQuery('.slick-slide').each(function(){
        if(jQuery(this).hasClass('slick-active'))
          jQuery(this).find('.smartwishlist').attr('tabindex','0');
        else
          jQuery(this).find('.smartwishlist').attr('tabindex','-1');
      });
  
      setTimeout(function(){
        slick.$slider.find('.slick-slide:not(.slick-active)').attr('tabindex', -1);
      }, 1000);
    }
}

_theme.toggleLoading = function(show){
  if(show){
    jQuery('.loading-modal').removeClass('hidden').show();
  } else {
    jQuery('.loading-modal').addClass('hidden').hide();
  }
}

_theme.toggleSideCart = function(show, elem, isAutoAction){
  if(show){
    jQuery('html').addClass('cart-show');
    jQuery('.wrapper-overlay').addClass('active');
    if(jQuery('.products-grid.new-products-grid').hasClass('slick-initialized')) jQuery('.products-grid.new-products-grid').slick('refresh');
    if(jQuery('.empty-cart-products').hasClass('slick-initialized')) jQuery('.empty-cart-products').slick('refresh');

    setTimeout(function () {  
      const side_bar_quickview = document.querySelector('cart-offer-list.active .sideoofers-close');
      if(side_bar_quickview){
          side_bar_quickview.click();
      }
      var url = window.location.href;
      if(url.indexOf('cart') > -1){
        const wrapper_overylay = document.querySelector('.wrapper-overlay.active');
        if(wrapper_overylay){
          wrapper_overylay.click();
        }
      } 
    }, 600); 
    // track action: Datalayer
    _theme.track.trackEvent('minicart_opened', isAutoAction ? 'add to cart click' : 'cart icon click');

    _theme.focusTrap(jQuery('#dropdown-cart'), function() {
      _theme.toggleSideCart(false, elem, false);
    });
  } else {
    $('cart-offer-list').attr('aria-hidden','true');
    jQuery('html').removeClass('cart-show');
    jQuery('.wrapper-overlay').removeClass('active');
    _theme.toggleSideCartQv();
    
    // track action: Datalayer
    _theme.track.trackEvent('minicart_closed', isAutoAction ? 'outside click' : 'cross icon click');

    if(elem) elem.focus();
    else jQuery('[data-cart-toggle]').focus();
  }
}

_theme.toggleSideCartQv = function(show){
    if(show){
       const cartOfferList = document.querySelector('cart-offer-list');
      if(cartOfferList){
        cartOfferList.classList.add('product_active');
      }
        jQuery('.sidecart-qv [data-tabindex-toggle]').attr('tabindex', 0);
        jQuery('.wrapper-overlay').addClass('active');
        jQuery('.sidecart-qv').addClass('active');
    } else {
        jQuery('.sidecart-qv [data-tabindex-toggle]').attr('tabindex', -1);
        jQuery('.sidecart-qv').removeClass('active');
        $('.wrapper-overlay').removeClass('active');
        const cartOfferList = document.querySelector('cart-offer-list');
        if(cartOfferList){
          cartOfferList.classList.remove('product_active');
        }
        const activeCollection = document.querySelector('.cart-offer-container');
        if(activeCollection){
          activeCollection.style.display = 'block';
        }
    }
}

_theme.initSmartWishlist = function(){
    if(window.SmartWishlistMain) window.SmartWishlistMain();
}

_theme.handleKeyboardEnterOrSpacePress = function(evt, watchUpDownArrowKey, className, callback){
  if(!evt.code || !evt.key) return;
  const key = evt.code ? evt.code.toUpperCase() : evt.key.toUpperCase();
  const target = evt.target;
  if(key === 'ENTER' || (key === ' ' && evt.which === 32)){
    target.click();
    target.classList.remove('select');
    if(callback && typeof callback === 'function') callback();
  }

  if(!watchUpDownArrowKey) return;

  const prevKeys = ['ARROWUP', 'ARROWLEFT'];
  const nextKeys = ['ARROWDOWN', 'ARROWRIGHT'];
  const elemClass = className || 'select';
  if(prevKeys.indexOf(key) > -1 && target.previousElementSibling){
    target.previousElementSibling.focus();
    target.classList.remove(elemClass);
    target.previousElementSibling.classList.add(elemClass);
  }
  if(nextKeys.indexOf(key) > -1 && target.nextElementSibling){
    target.nextElementSibling.focus();
    target.classList.remove(elemClass);
    target.nextElementSibling.classList.add(elemClass);
  }
}

_theme.initPriceOff = function(){
    jQuery(".custom-discount").each(function() {
      var t = Number(jQuery(this).attr("data-old-price").replace("$", ""))
        , e = Number(jQuery(this).attr("data-current-price").replace("$", ""));
      if (e > t)
          jQuery(this).text("");
      else {
          var a = (t - e) / t * 100;
          jQuery(this).html("<span class='text'>Up to</span><span class='discount_text'>"+Math.floor(a).toFixed(0)+"% Off</span>")
      }
      // jQuery(this).closest('.price-box').show();
    })
}

_theme.toggleAjaxModal = function(show, msg){
    if(show && msg){
      jQuery('.ajax-error-modal .ajax-error-message').text(msg);
      jQuery('.ajax-error-modal').fadeIn();
      setTimeout(function(){
        jQuery('.ajax-error-modal').fadeOut();
      }, 2000);
    } else {
      jQuery('.ajax-error-modal').fadeOut();
    }
}

_theme.initTooltip = function(){
  const qtBtns = document.querySelectorAll('.toolTipToggle');
  qtBtns.forEach(btn => {
    btn.removeEventListener('focusin', run);
    btn.addEventListener('focusin', run);
  });

  function run(evt){
    const target = evt.target;
    target.classList.add('show-tooltip');
    setTimeout(() => {
      target.classList.remove('show-tooltip');
    }, 2500);
  }
}

_theme.initListrakCartUpdateEvent = function(){
  if(!window._ltk) return;

  Shopify.getCart(function(cartjson){
    var r = cartjson.items, u = {}, i;
    if (r.length > 0) {
        for (i = 0; i < r.length; i++) {
            var t = r[i]
              , f = _ltk.Shopify.GetSkuProperty(t.id, t.sku)
              , e = t.title
              , o = t.quantity
              , s = t.final_price / 100
              , h = t.image
              , c = t.url;
            _ltk.SCA.AddItemWithLinks(f, o, s, e, h, c);
            i <= 9 && (u[t.variant_id] = t.quantity)
        }
        _ltk.SCA.Meta1 = cartjson.token;
        _ltk.SCA.CartLink = encodeURI(JSON.stringify(u).replace(/:/gi, "-")).replace(/,/gi, "%2C");
        _ltk.SCA.Submit()
    } else
        _ltk.SCA.ClearCart()
  });
}

_theme.Helpers = (function(){
    function setParamInURL(param, value, _url){
      if(!_url) _url = window.location.href;
      var url = new URL(_url);
      var search_params = url.searchParams;
      search_params.set(param, value);
      let pageVal = search_params.get('page');
      pageVal = 1
      search_params.set('page',pageVal);
      url.search = search_params.toString();
      var new_url = url.toString();

      return new_url;
    }
    function getParamFromURL(param, _url){
      if(!_url) _url = window.location.href;

      var url = new URL(_url);
      var search_params = url.searchParams;
      var paramVal = search_params.get(param);

      return paramVal;
    }
    function deleteParamFromURL(param, _url){
      if(!param) return null;
      if(!_url) _url = window.location.href;
      var url = new URL(_url);
      var search_params = url.searchParams;
      search_params.delete(param);
      var new_url = url.toString();
      return new_url;
    }
    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    function eraseCookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    function changeLineItemQty(line, qty, viaId, successCB, errorCB){
      let data = {quantity: qty, line: line, sections: 'gwp,minicart', sections_url: '/'};
      if(viaId){
        data = { quantity: qty, id: line, sections: 'gwp,minicart', sections_url: '/' }
      }

      jQuery.ajax({
        type: "post",
        url: "/cart/change.js",
        data: data,
        dataType: 'json',
        success:function(data){
          if(successCB && typeof successCB === 'function') successCB(data);
        },
        error:function(err){
          _theme.toggleAjaxModal(1, jQuery.parseJSON(err.responseText).description);
          if(errorCB && typeof errorCB === 'function') errorCB(err);
        }
      });
    }

    function goToPreviousPage(){
      window.history.back();
   }

   function addProductToCart(vid, qty, props, successCB, errorCB, target){
    if(!vid) return;

      let properties = null;
      if(props && typeof props === 'string') properties = {_proType: props};
      if(props && typeof props === 'object') properties = props;

      jQuery.ajax({
        url: window.routes.cart_add_url + '.js',
        method: 'POST',
        beforeSend: function() {
          _theme.toggleLoading(1);
        },
        data: {
          quantity: qty,
          id: vid,
          properties: properties,
          sections: 'gwp,minicart', sections_url: '/'
        },
        dataType: 'json',
        success:function(res){
          updateATCAccessibilityStatus('done', null , target);
          if(successCB && typeof successCB === 'function') successCB(res);
        },
        error: function(err){
          _theme.toggleAjaxModal(1, jQuery.parseJSON(err.responseText).description);
          if(errorCB && typeof errorCB === 'function') errorCB(err);
        },
        complete: function(){
          _theme.toggleLoading();
        }
      });
    }
    function updateATCAccessibilityStatus(status, msg, target){
      const ariaElem = typeof(target) === 'object' && target?.closest('form')?.querySelector('#pdp-atc-status');
      if(!ariaElem || !status) return;
      switch(status){
        case 'in-progress':
          ariaElem.textContent = 'Adding';
          break;
        case 'done':
          ariaElem.textContent = 'Item added to your cart';
          break;
        case 'error':
          ariaElem.textContent = msg || 'Something went wrong';
          break;
        default:
          ariaElem.textContent = '';
      }

      setTimeout(() => {
        ariaElem.textContent = '';
      }, 3000);
    }
    function removeItemsFromCart(items){
      if(!items || items.length === 0) return;

      const updates = {};
      items.forEach(function(vid){
        updates[vid] = 0;
      });

      fetch('/cart/update.js', {
        method: "post",
        headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
        },
        body: JSON.stringify({
          updates: updates
        })
      }).then(function(res){
        return res.json();
      }).then(function(res){
        window.location.reload();
      }).catch(function(err){
        console.log(err);
        _theme.toggleAjaxModal(1, jQuery.parseJSON(err.responseText).description);
      });
    }
    function handleize(str){
      return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }
    function setItemIntoLS(key, value){
      if(typeof localStorage === undefined || typeof localStorage === null) return;
      if(typeof value !== 'string'){
        value = JSON.stringify(value);
      }
      localStorage.setItem(key, value);
      return true;
    }
    function getItemFromLS(key){
      if(typeof localStorage === undefined || typeof localStorage === null) return;
      let value = localStorage.getItem(key);
      return JSON.parse(value);
    }
    function removeItemFromLS(key){
      if(typeof localStorage === undefined || typeof localStorage === null) return;
      localStorage.removeItem(key);
      return true;
    }
    // Session Storage
    function setItemIntoSS(key, value){
      if(typeof sessionStorage === undefined || typeof sessionStorage === null) return;
      if(typeof value !== 'string'){
        value = JSON.stringify(value);
      }
      sessionStorage.setItem(key, value);
      return true;
    }
    function getItemFromSS(key){
      if(typeof sessionStorage === undefined || typeof sessionStorage === null) return;
      let value = sessionStorage.getItem(key);
      return JSON.parse(value);
    }
    function removeItemFromSS(key){
      if(typeof sessionStorage === undefined || typeof sessionStorage === null) return;
      sessionStorage.removeItem(key);
      return true;
    }
  
    function showNotification(msg, delay){
      const toastModel = document.querySelector('[data-toast-notify]');
      if(!msg || !toastModel) return;
      toastModel.querySelector('[data-toastmsg]').innerHTML = msg;
      toastModel.classList.add('active');

      setTimeout(function(){
          toastModel.classList.remove('active');
      }, delay || 3000);
    }
    function toggleLoader(show) {
      const loader = document.querySelector(".loading-modal");
      if (!loader) return;
      if (show) loader.classList.add("show");
      else loader.classList.remove("show");
    }
    function fetchOfferData() {
      return fetch("/cart?view=free-offers")
        .then(function (res) {
          return res.json();
        })
        .then(function (dd) {
          return dd;
        })
        .catch(function (err) {
          console.log(err);
        });
    }
    function isNumberKey(evt){
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
          return false;

      return true;
    }

     // with exception that this one handles context passing
     const throttle = (fn, ms = 300) => {
      let lastCall = Date.now() - 2 * ms
      let result
      let trailing
      function invoke(...args) {
          lastCall = Date.now()
          return (result = fn.apply(this, args))
      }
      return function throttler(...args) {
          const now = Date.now()
          if (now - lastCall >= ms) {
              return invoke.apply(this, args)
          }
          clearTimeout(trailing)
          trailing = setTimeout(() => invoke.apply(this, args), lastCall - now + ms)
          return result
      }
    }

    function updateHtml(html, str, data){
      var newhtml = html;
      if(newhtml.indexOf(str) > -1){
        newhtml = newhtml.replace(str, data);
        return this.updateHtml(newhtml, str, data);
      } else {
        return newhtml;
      }
    }

    function validateEmail(email){
      if(!email) email = '';
      const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return email.match(regex);
    }

    function refreshKlarna(){
      if(window.Klarna && Klarna.OnsiteMessaging) Klarna.OnsiteMessaging.refresh();
    }

    function getFormattedDate(date){
      if(!date) return '';
      const d = new Date(date);
      let dateVal = d.getDate();
      dateVal = dateVal >= 10 ? dateVal : ('0' + dateVal);
      let month = d.getMonth() + 1;
      month = month >= 10 ? month : ('0' + month);
      const formattedDate = month + '/' + dateVal + '/' + d.getFullYear();
      return formattedDate;
    }

    function getFormattedTime(date){
      if(!date) return '';
      const d = new Date(date);
      let hours = d.getHours();
      let minutes = d.getMinutes();
      const timeLabel = hours < 12 ? 'AM' : 'PM';
      hours = hours <= 12 ? hours : (hours - 12);
      hours = hours >= 10 ? hours : ('0' + hours);
      minutes = minutes >= 10 ? minutes : ('0' + minutes);
      const formattedTime = hours + ':' + minutes + ' ' + timeLabel;
      return formattedTime;
    }

    function stringToHTML(str){
      if(!str) return null;
  
      var parser = new DOMParser();
      var doc = parser.parseFromString(str, 'text/html');
      return doc.body;
    }

    async function updateCartAttributes(attrs){
      if(!attrs) return Promise.reject('Invalid attributes');

      const attributes = {
        "attributes": attrs
      };

      fetch('/cart/update.js', {
        method: "post",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(attributes)
      }).then(function(res) {
        return res.json()
      }).then(function(res) {
        return res;
      });
    }

    function generateUUID() { // Public Domain/MIT
      var d = new Date().getTime();//Timestamp
      var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16;//random number between 0 and 16
          if(d > 0){//Use timestamp until depleted
              r = (d + r)%16 | 0;
              d = Math.floor(d/16);
          } else {//Use microseconds since page-load if supported
              r = (d2 + r)%16 | 0;
              d2 = Math.floor(d2/16);
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }
    
    function insertAfter(referenceNode, newNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    function formatPrice(amount){
      return  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount || 0)
    }

    // EST/EDT Time Utility Functions
    function getESTOffset(date) {
      // EST = UTC-5 (300), EDT = UTC-4 (240)
      const year = date.getFullYear();

      // Find 2nd Sunday in March (DST start)
      const marchFirst = new Date(year, 2, 1);
      const marchFirstDay = marchFirst.getDay();
      const secondSundayMarch = 1 + ((7 - marchFirstDay) % 7) + 7;

      // Find 1st Sunday in November (DST end)
      const novemberFirst = new Date(year, 10, 1);
      const novemberFirstDay = novemberFirst.getDay();
      const firstSundayNovember = 1 + ((7 - novemberFirstDay) % 7);

      // Create dates for DST range
      const dstStart = new Date(year, 2, secondSundayMarch, 2); // 2 AM EST
      const dstEnd = new Date(year, 10, firstSundayNovember, 2); // 2 AM EDT

      // Check if date is within DST range
      const isDST = date >= dstStart && date < dstEnd;

      return isDST ? 240 : 300; // EDT: -4h, EST: -5h
    }

    function parseESTDate(dateStr, timeStr) {
      try {
        if (!dateStr || !timeStr) {
          return new Date(0);
        }

        let year, month, day;

        // Parse date string - handle both YYYY-MM-DD and "Month Day, Year" formats
        if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {

          // YYYY-MM-DD format (e.g., "2025-10-21")
          const dateParts = dateStr.split('-');
          year = parseInt(dateParts[0], 10);
          month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in Date
          day = parseInt(dateParts[2], 10);
        } else {
          
          // Try parsing as a date string (e.g., "July 2, 2025")
          const tempDate = new Date(dateStr);
          if (isNaN(tempDate.getTime())) {
            console.error('Invalid date format:', dateStr);
            return new Date(0);
          }
          year = tempDate.getFullYear();
          month = tempDate.getMonth();
          day = tempDate.getDate();
        }

        // Parse time string (e.g., "10:00 AM" or "1:17 PM")
        const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        if (!timeMatch) {
          console.error('Invalid time format:', timeStr);
          return new Date(0);
        }

        let hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);
        const ampm = timeMatch[3].toUpperCase();

        // Convert to 24-hour format
        if (ampm === 'PM' && hours !== 12) {
          hours += 12;
        } else if (ampm === 'AM' && hours === 12) {
          hours = 0;
        }

        // Create a date object to determine EST/EDT offset for this date
        const testDate = new Date(year, month, day, hours, minutes, 0);
        const estOffsetMinutes = getESTOffset(testDate);
        
        // Create date as if it's in EST/EDT timezone
        // We'll create it in local timezone, then adjust to represent EST/EDT
        const localDate = new Date(year, month, day, hours, minutes, 0);
        const localOffsetMinutes = localDate.getTimezoneOffset();
        
        // Convert EST/EDT time to UTC timestamp
        // UTC timestamp = local timestamp - localOffset + estOffset
        const utcTimestamp = localDate.getTime() - (localOffsetMinutes * 60000) + (estOffsetMinutes * 60000);
        
        return new Date(utcTimestamp);
      } catch (error) {
        console.error('Error parsing EST date:', error);
        return new Date(0);
      }
    }

    function getCurrentESTTime() {
      const now = new Date();

      // Get current time components in EST/EDT
      const estString = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      // Parse EST string: "MM/DD/YYYY, HH:MM:SS"
      const estMatch = estString.match(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/);
      if (estMatch) {
        const estMonth = parseInt(estMatch[1], 10) - 1;
        const estDay = parseInt(estMatch[2], 10);
        const estYear = parseInt(estMatch[3], 10);
        const estHours = parseInt(estMatch[4], 10);
        const estMinutes = parseInt(estMatch[5], 10);
        const estSeconds = parseInt(estMatch[6], 10);

        // Create date object representing EST time in local timezone
        const estDate = new Date(estYear, estMonth, estDay, estHours, estMinutes, estSeconds);

        // Get EST/EDT offset and local offset
        const estOffsetMinutes = getESTOffset(estDate);
        const localOffsetMinutes = estDate.getTimezoneOffset();

        // Convert EST/EDT time to UTC timestamp
        // Formula: UTC = localTimestamp - localOffset + estOffset
        const utcTimestamp = estDate.getTime() - localOffsetMinutes * 60000 + estOffsetMinutes * 60000;

        return utcTimestamp;
      }

      // Fallback: return current UTC time
      return now.getTime();
    }
 
    return {
      setParamInURL: setParamInURL,
      getParamFromURL: getParamFromURL,
      deleteParamFromURL: deleteParamFromURL,
      setCookie: setCookie,
      getCookie: getCookie,
      eraseCookie: eraseCookie,
      addProductToCart: addProductToCart,
      updateATCAccessibilityStatus: updateATCAccessibilityStatus,
      removeItemsFromCart: removeItemsFromCart,
      changeLineItemQty: changeLineItemQty,
      handleize: handleize,

      setItemIntoLS: setItemIntoLS,
      getItemFromLS: getItemFromLS,
      removeItemFromLS: removeItemFromLS,

      setItemIntoSS: setItemIntoSS,
      getItemFromSS: getItemFromSS,
      removeItemFromSS: removeItemFromSS,

      showNotification: showNotification,
      toggleLoader: toggleLoader,
      fetchOfferData: fetchOfferData,
      isNumberKey: isNumberKey,
      updateHtml: updateHtml,
      validateEmail: validateEmail,
      refreshKlarna: refreshKlarna,
      throttle: throttle,
      getFormattedDate: getFormattedDate,
      getFormattedTime: getFormattedTime,
      stringToHTML: stringToHTML,
      updateCartAttributes: updateCartAttributes,
      goToPreviousPage: goToPreviousPage,
      generateUUID: generateUUID,
      insertAfter: insertAfter,
      formatPrice: formatPrice,
      getESTOffset: getESTOffset,
      parseESTDate: parseESTDate,
      getCurrentESTTime: getCurrentESTTime
    }
})();

// Smart Wishlist
_theme.handleWishlistChange = function(){
  let t=document.querySelectorAll(".smartwishlist");
  t.forEach(function(t,e){
    let i=t.dataset.title;
    if(!t.getAttribute('aria-controls')) t.setAttribute('aria-controls', 'wishlist-sr-only');
    t.removeAttribute('title');
    
    if(!i)return;
    if(t.classList.contains("bookmarked")){
      t.setAttribute("aria-label", "Remove from Wishlist " + i);
    } else {
      t.setAttribute("aria-label","Add to Wishlist " + i);
    }
  });

  setTimeout(updateWishlistCount, 1000);

  function updateWishlistCount(){
    const topbadge = document.querySelector('.topbadge');
    if(!topbadge) return;
    topbadge.setAttribute('aria-hidden', true);
    const parent = topbadge.parentElement;
    if(parent.querySelector('.visually-hidden')) parent.querySelector('.visually-hidden').remove();
    const srOnly = document.createElement('span');
    srOnly.classList.add('visually-hidden');
    const count = Number(topbadge.textContent);
    if(count === NaN) return;
    srOnly.innerHTML = ' &nbsp;with ' + count + ' ' + ((count > 1) ? 'items' : 'item');
    parent.appendChild(srOnly);    
  }
}

_theme.handleWishlistStatus = function(isAdded){
  const wishlistSrOnly = document.getElementById('wishlist-sr-only');
  if(!wishlistSrOnly) return;
  if(isAdded) wishlistSrOnly.textContent = 'Added to wishlist';
  else wishlistSrOnly.textContent = 'Removed from wishlist';
  setTimeout(() => {wishlistSrOnly.textContent = ''}, 3000);
}

_theme.updateGWP = function(resp){
  const gwpblock = document.querySelector('gwp-block');
  if(gwpblock && resp.sections && resp.sections.gwp){
    const gwpblockInner = gwpblock.querySelector('.gwp-block');
    if(gwpblockInner && resp.item_count !== null && resp.item_count !== undefined){
      if(resp.item_count === 0){
        gwpblockInner.setAttribute('aria-hidden', true);
      } else {
        gwpblockInner.setAttribute('aria-hidden', false);
      }
    }

    const gwpBody = _theme.Helpers.stringToHTML(resp.sections.gwp);
    if(gwpBody){
      const respGWPBlock = gwpBody.querySelector('gwp-block');
      gwpblock.innerHTML = respGWPBlock.innerHTML;
    }
  }
}

_theme.toggleOverlay = function(show){
  if(show){
    $('.wrapper-overlay').addClass('active');
  } else {
    $('.wrapper-overlay').removeClass('active');
  }
}

function SWCallbackCustomerWishlistCollectionItemAdded(){
  _theme.handleWishlistChange();
  _theme.handleWishlistStatus(true);
}
function SWCallbackCustomerWishlistCollectionItemRemoved(){
  _theme.handleWishlistChange();
  _theme.handleWishlistStatus(false);
}
function SWCallbackExpressWishlistCollectionItemAdded(){
  _theme.handleWishlistChange();
  _theme.handleWishlistStatus(true);
}
function SWCallbackExpressWishlistCollectionItemRemoved(){
  _theme.handleWishlistChange();
  _theme.handleWishlistStatus(false);
}